import React from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import { isBoolean } from 'lodash';
import PropTypes from 'prop-types';

const GlobalityLabelCDS = ({ isGlobal, size }) => {
  if (!isBoolean(isGlobal)) {
    return null;
  }

  return (
    <LabelCDS
      size={size}
      title={isGlobal ? 'Global' : 'Local'}
      variant={isGlobal ? LabelVariant.BLUE : LabelVariant.CYAN}
    />
  );
};

GlobalityLabelCDS.propTypes = {
  isGlobal: PropTypes.bool,
  size: PropTypes.string,
};

export default GlobalityLabelCDS;
